import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const SupportIcon = ({ color = '#0D84FE', size = 17, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    viewBox="0 0 17 16"
    {...props}
  >
    <path
      fill={color}
      d="M10.215 14.938c0-.587-.476-1.063-1.064-1.063H7.85a1.065 1.065 0 0 0-1.064 1.063c0 .586.476 1.062 1.064 1.062H9.15c.588 0 1.064-.476 1.064-1.062Zm-7.978-2.74c.177.014.392.021.608.009a3.015 3.015 0 0 0 2.963 2.432h.406a1.658 1.658 0 0 0 0 .597h-.406a3.62 3.62 0 0 1-3.571-3.038Zm-.304-.635A2.319 2.319 0 0 1 0 9.28V7.87a2.313 2.313 0 0 1 2.318-2.315h.154A6.044 6.044 0 0 1 8.5 0a6.044 6.044 0 0 1 6.028 5.555h.154A2.32 2.32 0 0 1 17 7.87v1.41a2.313 2.313 0 0 1-2.318 2.315h-.684a.513.513 0 0 1-.514-.513V6.04A4.981 4.981 0 0 0 8.5 1.06a4.981 4.981 0 0 0-4.984 4.978v5.043c0 .2-.115.374-.282.458-.46.16-1.175.044-1.301.023Z"
    />
  </svg>
);

SupportIcon.propTypes = propTypes;

export default SupportIcon;
